import Vue from 'vue'
import moment from 'moment'
import 'moment-duration-format'

Vue.filter('capitalize', function (value) {
  if (!value) return ''
  value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1)
})

Vue.filter('format_currency', function (num) {
  if (!num) return '0'
  let result = '0'
  if (num) {
    result = num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  }
  return result
})

Vue.filter('format_date', function (dateTime) {
  if (!dateTime) return ''
  let result = ''
  if (dateTime) {
    result = moment(dateTime).format('YYYY-MM-DD')
  }
  return result
})

Vue.filter('format_month', function (dateTime) {
  if (!dateTime) return ''
  let result = ''
  if (dateTime) {
    result = moment(dateTime).format('YYYY-MM')
  }
  return result
})

Vue.filter('format_date_time', function (dateTime) {
  if (!dateTime) return ''
  let result = ''
  if (dateTime) {
    result = moment(dateTime).format('YYYY-MM-DD HH:mm:ss')
  }
  return result
})

Vue.filter('truncate', function (text, length = 20, clamp = '...') {
  return text.length > length ? text.slice(0, length) + clamp : text
})

Vue.filter('countime_up', function (duration) {
  return moment.duration(duration, 'seconds').format('*mm:ss')
})



// WEBPACK FOOTER //
// ./src/filters/index.js